import { render, staticRenderFns } from "./HorseComparationLessonSelect.vue?vue&type=template&id=d0906850&scoped=true&"
import script from "./HorseComparationLessonSelect.vue?vue&type=script&lang=js&"
export * from "./HorseComparationLessonSelect.vue?vue&type=script&lang=js&"
import style0 from "./HorseComparationLessonSelect.vue?vue&type=style&index=0&id=d0906850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0906850",
  null
  
)

export default component.exports